import { render, staticRenderFns } from "./charts-bar.vue?vue&type=template&id=3b8b00bf&scoped=true&"
import script from "./charts-bar.vue?vue&type=script&lang=ts&"
export * from "./charts-bar.vue?vue&type=script&lang=ts&"
import style0 from "./charts-bar.vue?vue&type=style&index=0&id=3b8b00bf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8b00bf",
  null
  
)

export default component.exports